module.exports = __webpack_public_path__ + "static/media/WDTJSSAEFTMALC2_1.7e50f9ec.png";